export default function MacbookSafariFrame() {
  return (
    <div className="w-full h-full transform scale-140 origin-top">
      {/* Safari Browser Chrome - Reduced height */}
      <div className="bg-gradient-to-b from-gray-100 to-gray-200 rounded-t-lg border border-gray-300 p-0.5">
        <div className="flex items-center h-6 bg-white rounded-md px-2">
          <div className="flex space-x-1.5 mr-2">
            <div className="w-2.5 h-2.5 rounded-full bg-red-500"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-yellow-500"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-green-500"></div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="w-4/5 h-5 bg-gray-100 rounded-md flex items-center px-3 text-xs text-gray-500 font-medium">
              app.juhuu.app
            </div>
          </div>

          <div className="w-6"></div>
        </div>
      </div>

      {/* Browser Content - Adjusted aspect ratio for more vertical space */}
      <div className="relative bg-white border-x border-b border-gray-300 rounded-b-lg shadow-md overflow-hidden">
        <div className="relative w-full pb-[75%]">
          {/* Loading animation */}
          <div className="absolute inset-0 flex items-center justify-center bg-white">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>

          {/* Actual iframe instead of image */}
          <iframe
            src="https://app.juhuu.app"
            className="absolute inset-0 w-full h-full border-0"
            title="JUHUU Web App"
            sandbox="allow-scripts allow-same-origin allow-forms"
          ></iframe>
        </div>
      </div>
    </div>
  )
}
